import React, { useMemo, useContext, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';

import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { MessageBar, MessageBarButton } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { getAlertMessageStyles } from '../../styles/top-key-card';
import { ActionTextKey, IconName, MessageBarTypes, Severity } from '../../constants';

const { BudgetEventType, SecurityAction } = Constants;

export const AlertMessage = ({
  i18n,
  budgetEventTypes,
  onUpdateBudget,
  authzMap,
}) => {
  const classes = useDefaultStyles(getAlertMessageStyles);
  const activity = useContext(ActivityContext);
  const messageConfig = useMemo(() => {
    if (_.find(budgetEventTypes, item => item === BudgetEventType.CampaignOutOfBudget)) {
      return {
        severity: Severity.Error,
        message: i18n.getString(_TL_('This campaign is out of budget. Please adjust your budget to ensure your ads keep serving.')),
      };
    }
    return null;
  }, [budgetEventTypes, i18n]);
  const hasAction = !!_.get(authzMap, SecurityAction.CampaignManagementFullControl);
  const handleClick = useCallback(() => {
    activity && activity.trace(`BudgetEventType: ${BudgetEventType.CampaignOutOfBudget}`, 'ActionClick-AlertMessage');
    onUpdateBudget();
  }, [activity, onUpdateBudget]);

  useEffect(() => {
    if (messageConfig) {
      activity && activity.trace(JSON.stringify({ BudgetEventType: BudgetEventType.CampaignOutOfBudget, hasAction }), 'Show-AlertMessage');
    }
  }, [activity, hasAction, messageConfig]);

  return messageConfig && (
    <MessageBar
      className={classnames('top-key-card-alert-message-bar', classes.MessageBar)}
      messageBarType={MessageBarTypes[messageConfig.severity]}
      messageBarIconProps={{ iconName: IconName[messageConfig.severity], className: classes[`Icon-Severity-${messageConfig.severity}`] }}
    >
      <span className={classnames('alert-message-text', classes.MessageText)}>{messageConfig.message}</span>
      {hasAction && <MessageBarButton className="alert-message-action" onClick={handleClick}>{i18n.getString(ActionTextKey.AdjustBudget)}</MessageBarButton>}
    </MessageBar>
  );
};

AlertMessage.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  budgetEventTypes: PropTypes.arrayOf(PropTypes.number),
  onUpdateBudget: PropTypes.func,
  authzMap: PropTypes.shape({}),
};

AlertMessage.defaultProps = {
  budgetEventTypes: [],
  onUpdateBudget: _.noop,
  authzMap: {},
};
